import { QICK_APP_LOGIN_URL } from "@/lib/routes";
import { supabase, supabaseConfigError } from "@/lib/supabaseClient";

const requireSupabase = () => {
    if (!supabase) {
        throw new Error(supabaseConfigError);
    }

    return supabase;
};

export const signUpWithEmail = async ({ name, companyName, email, password }) => {
    const client = requireSupabase();

    return client.auth.signUp({
        email,
        password,
        options: {
            data: {
                name,
                company_name: companyName,
            },
            emailRedirectTo: QICK_APP_LOGIN_URL,
        },
    });
};

export const signInWithEmail = async ({ email, password }) => {
    const client = requireSupabase();

    return client.auth.signInWithPassword({
        email,
        password,
    });
};

export const signOut = async () => {
    const client = requireSupabase();
    return client.auth.signOut();
};

export const getCurrentSession = async () => {
    if (!supabase) return { data: { session: null }, error: null };
    return supabase.auth.getSession();
};

export const getCurrentUser = async () => {
    if (!supabase) return { data: { user: null }, error: null };
    return supabase.auth.getUser();
};

export const onAuthStateChange = (callback) => {
    if (!supabase) return () => {};

    const { data } = supabase.auth.onAuthStateChange(callback);
    return () => data.subscription.unsubscribe();
};
